import { useContext, useState } from "react";
import {
  ConfigCurva,
  ConfigFooter,
  ConfigTecladoContainer,
  ContainerConfig,
} from "./localStyle";
import { useHistory } from "react-router";
import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";
import { wsGetConfig } from "global/context/action/config/config";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import CardConfig from "_+_Portal/_-_Autocheckin/components/genericos/CardConfig/CardConfig";
import TecladoAlfanumerico from "_+_Portal/components/Genericos/TecladoAlfanumerico/TecladoAlfanumerico";

const Config = () => {
  //#region --------- context ---------------
  const { toasterDispatch } = useContext(GlobalContext);
  //#endregion  ----- context ---------------

  const [loading, setLoading] = useState(false);
  const history = useHistory();
  let idTerminal = localStorage.getItem("idTerminal");
  idTerminal = idTerminal ? idTerminal : "";
  idTerminal = idTerminal.replaceAll('"', "");
  const [state, setState] = useState(idTerminal);
  const maxLength = 20;

  //#region  ----------- constants ---------------
  //#endregion --------- constants ---------------
  //#region  ----------- funciones ---------------
  const onChangeTeclado = (value) => {
    setState(value);
  };
  const onDeleteTeclado = () => {
    setState("");
  };
  const onclick = () => {
    let nextStep = (isCorrect, data) => {
      setLoading(false);
      if (isCorrect) {
        localStorage.setItem(
          "opcRecepConLlamador",
          JSON.stringify(data.recepConLlamador)
        );
        localStorage.setItem("idTerminal", JSON.stringify(data.nombre));
        localStorage.setItem("dataComplete", JSON.stringify(data));
        history.push("/");
      } else {
        showToaster(
          {
            texto: "El id ingresado no es correcto",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    };
    setLoading(true);
    wsGetConfig(state, nextStep);
  };
  const handleKeyUp = (e) => {
    if (e.key === "Enter") {
      onclick();
    }
  };
  //#endregion --------- funciones ---------------
  return (
    <>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />
      <ContainerConfig>
        <CardConfig
          state={state}
          setLoading={setLoading}
          onclick={onclick}
          handleKeyUp={handleKeyUp}
        />
        <ConfigFooter>
          <ConfigCurva />
          <ConfigTecladoContainer>
            <TecladoAlfanumerico
              sinNumeros={false}
              modeLight={true}
              onEnter={onclick}
              enterStr={"Enter"}
              onChange={onChangeTeclado}
              maxLength={maxLength}
              onDelete={onDeleteTeclado}
            />
          </ConfigTecladoContainer>
        </ConfigFooter>
      </ContainerConfig>
    </>
  );
};

export default Config;
